<template>
  <div class="pay-vip-wrapper">
    <div class="child-info">
      <div class="child">
        <span>您的孩子</span>
        <span class="child-name">{{childInfo.nickname}}</span>
        <span class="child-id">(ID: getLansiID{{childInfo.userId}})</span>
      </div>
      <div class="date-wrapper">
        <span>会员将于 <span class="time">{{finishDate}}</span> 到期</span>
      </div>
    </div>
    <CommenBuyVip :childUserId="childInfo.userId"/>
  </div>
</template>

<script>
    import CommenBuyVip from "@/components/commonBuyVip/CommenBuyVip";
    import moment from "moment";
    import {creatLansiId} from "@/lib/util";
    export default {
        name: "Payvip",
        data(){
          return {
            childInfo: {}
          }
        },
        computed: {
          finishDate() {
            return moment(this.childInfo.vipExpireDate).format('YYYY-MM-DD')
          }
        },
        components: {
          CommenBuyVip
        },
        activated() {
          this.childInfo = JSON.parse(this.$route.query.childInfo) ;
        },
        methods: {
          getLansiID(userId) {
            return creatLansiId(userId)
          },
        }
    }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  @import "../stylesheet/common.styl"
  .pay-vip-wrapper{
    min-height: 100vh;
    box-sizing: border-box;
    padding: 30px 20px;
  }

  .child-info{
    border: 1px solid $common-line-color;
    border-radius: 6px;
    padding: 16px;
    .child-name {
      font-weight: bold;
    }
    .child-id{
      margin-left: 4px;
      color: #A1A1A1;
    }
    .date-wrapper{
      margin-top: 6px;
      .time{
        color: $common-red;
        font-weight: bold;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// app/pages/pay/Payvip.vue